import { createFileRoute } from '@tanstack/react-router';
import { PERMISSION_COST_CENTERS } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

export const Route = createFileRoute('/_authenticated/system_settings/cost-centers/')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_COST_CENTERS, ['read'], '/unauthorized', context);

    return {
      ...context,
      documentTitle: {
        main: 'tab.cost-centers',
        suffix: 'table.systemSettings',
      },
    };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: CostCentersRoute,
});

function CostCentersRoute() {
  return null;
}
